import Button from 'components/button';
import ImageResponsive from 'components/imageResponsive';
import React, { useCallback, useEffect, useState } from 'react';
import { fileToDataUri } from 'utils/fileToDataUri';

export interface IImagePreviewProps {
  imageFile: File;
  onRemoveImage?: () => void;
}

export const ImagePreview: React.FC<IImagePreviewProps> = ({ imageFile, onRemoveImage }) => {
  const [imageUri, setImageUri] = useState<string>('');

  useEffect(() => {
    (async () => {
      const imageUriResponse = await fileToDataUri(imageFile);

      setImageUri(imageUriResponse as unknown as string);
    })();
  }, [imageFile]);

  const handleRemoveImage = useCallback(() => {
    if (onRemoveImage) onRemoveImage();
  }, [onRemoveImage]);

  return (
    <div className='w-full'>
      <div className='w-full relative border border-hl-gray-x11 pb-100%'>
        <Button
          type='button'
          label='x'
          buttonVariant='tertiary'
          onClick={handleRemoveImage}
          className='!absolute right-2 top-2 w-fit !px-4 !py-2 z-10'
        />
        <ImageResponsive alt='preview-image' src={imageUri as unknown as string} className='!object-contain' />
      </div>
    </div>
  );
};
